import { _admin, _dewas, _direksi, _kpm, _spi } from "./menu";

const access = [
    { type: 'admin', route: _admin },
    { type: 'direksi', route: _direksi },
    { type: 'dewas', route: _dewas },
    { type: 'spi', route: _spi },
    { type: 'kpm', route: _kpm },
];
export default access